"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppStore = AppStore;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

function AppStore(props) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _core.jsx)("path", {
    d: "M11.79 9.032a3.86 3.86 0 011.839-3.239 3.95 3.95 0 00-3.113-1.682c-1.31-.138-2.58.783-3.247.783-.68 0-1.708-.77-2.814-.747A4.145 4.145 0 00.966 6.275c-1.508 2.611-.383 6.45 1.062 8.56.723 1.034 1.568 2.188 2.673 2.148 1.082-.045 1.486-.69 2.792-.69 1.294 0 1.673.69 2.8.663 1.161-.018 1.893-1.038 2.59-2.081.52-.737.92-1.55 1.185-2.412a3.73 3.73 0 01-2.277-3.431zM9.66 2.722A3.8 3.8 0 0010.53 0a3.866 3.866 0 00-2.502 1.294 3.616 3.616 0 00-.892 2.622A3.197 3.197 0 009.66 2.722z",
    fill: "currentColor"
  }));
}

AppStore.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppStore"
};